import { useEffect, useState, useMemo } from "react";
import { Card, CardContent, Typography, Box, Drawer, TextField } from "@mui/material";
import PatientMapRosterTableOpport from "./PatientMapComp/Table/PatientMapRosterTableOpport";
import CodingDetails from './PatientMapComp/SpecialistReferralFormProPostAudi';
import { getAHCAMap } from "../../../../utils/services/APP/AHCA/getAHCAMap";

    
const AHCA = () => {
    const [selectedCenter, setSelectedCenter] = useState('All');
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [openReferralForm, setOpenReferralForm] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [PrePostAudi, setPrePostAudi] = useState({});
    const [allData, setAlldata] = useState({});

    const handleAddPatient = (newPatient) => {
        setData(prev => {
            const exists = prev.some(patient => patient.MemberID === newPatient.MemberID);
            if (exists) {
            // Reemplazar el paciente existente por el nuevo
            return prev.map(patient =>
                patient.MemberID === newPatient.MemberID ? newPatient : patient
            );
            } else {
            // Agregar el nuevo paciente al final
            return [...prev, newPatient];
            }
        });
    };

    const handleSelectPatient = (patient) => {
        setSelectedPatient(patient);
        setOpenReferralForm(true)
    };

    const[data,setData]=useState([])
    useEffect(() => {
        const Information = getAHCAMap();
        setData(Information.data);
        setAlldata(Information)
        setPrePostAudi(Information.medicalCenters);
    }, []);

    // const counts = useMemo(() => {
    //     const grouped = {};
    //     data.forEach(item => {
    //     grouped[item.medicalCenter] = (grouped[item.medicalCenter] || 0) + 1;
    //     });
    //     return grouped;
    // }, [data]);

    const filteredData = useMemo(() => {
        let filtered = selectedCenter === 'All'
            ? data
            : data.filter(item => item.MedicalCenter === selectedCenter);

        if (searchText.trim()) {
            filtered = filtered.filter(item =>
            item.MemberFullName.toLowerCase().includes(searchText.toLowerCase())
            );
        }
        return filtered;
    }, [selectedCenter, data, searchText]);
    
  return (
    <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
            AHCA
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
            <TextField
                placeholder="Member Name"
                size="small"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{ width: '60%' }}
            />
        </Box>
        <Box sx={{ borderBottom: '1px solid #ddd', mb: 2 }} />
        {/* Contenedor principal en fila */}
        <Box sx={{ display: 'flex', gap: 2 }}>
            
            {/* Sidebar */}
            <Box
                sx={{
                    width: 200,
                    pr: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                }}
                >
                {Object.entries(PrePostAudi).map(([key, value]) => (
                <Box
                    key={key}
                    onClick={() => setSelectedCenter(key)}
                    sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    backgroundColor: selectedCenter === key ? '#d1f2eb' : 'transparent',
                    borderRadius: '999px',
                    px: 2,
                    py: 0.5,
                    fontWeight: selectedCenter === key ? 'bold' : 'normal',
                    border: selectedCenter === key ? '1px solid #117a65' : 'none',
                    color: selectedCenter === key ? '#117a65' : 'inherit',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#d1f2eb',
                    },
                    }}
                >
                    {key}{' '}
                    <span style={{ color: '#aaa', marginLeft: 4 }}>
                    ({value || 0})
                    </span>
                </Box>
                ))}

            </Box>


            {/* Contenido principal con la tabla */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Card>
                    <CardContent sx={{ p: 0 }}>
                    <Box 
                        sx={{ 
                        height: 700, 
                        overflowY: "auto"
                        }}
                    >

                        <PatientMapRosterTableOpport
                        data={filteredData}
                        loading={""}
                        total={allData.totalPages}
                        page={allData.page}
                        pageSize={allData.pageSize}
                        setPage={0}
                        setPageSize={0}
                        onSelectPatient={(p) => handleSelectPatient(p)}
                        />
                    </Box>
                    </CardContent>
                </Card>
            </Box>
        </Box>
        <Drawer anchor="right" open={openReferralForm} onClose={() => setOpenReferralForm(false)}>
            <Box width={650} p={3}>
                <CodingDetails
                    modificar={ selectedPatient?? [] }
                    open={openReferralForm}
                    onClose={() => setOpenReferralForm(false)}
                    onSave={(newReferral) => {
                        handleAddPatient(newReferral);
                        setOpenReferralForm(false);
                    }}
                />
            </Box>
        </Drawer>
    </Box>
    
  );
};


export default AHCA;

